<h2>{{ 'settings.countries' | transloco: {countryAlias} }}</h2>

<p>
  {{ 'settings.to-onboard-a-new-country-please-add-to-the-list-of-countries' | transloco: {countryAlias} }}
</p>

<div class="config-row">
  <div
    class="ui toggle checkbox config-toggle"
    (click)="toggleConfigExportMode()"
  >
    <input type="checkbox" [ngModel]="configExportMode" />
    <label>{{ "settings.export-config-mode" | transloco }}</label>
  </div>
</div>

<div class="country-filters">
  <div class="country-keyword-filter">
    <div class="ui left  fluid input">
      <i class="search icon country-input-icon"></i>
      <input
        type="text"
        [(ngModel)]="countrySearch"
        placeholder="{{ 'settings.search-countries' | transloco: {countryAlias} }}"
      />
    </div>
  </div>
  @if (!configExportMode) {
  <div class="country-actions">
    <button class="ui primary background button tiny" (click)="add()">
      {{ 'settings.add-country' | transloco: {countryAlias} }}
    </button>
  </div>
  } @if (configExportMode) {
  <div class="country-actions">
    @if (configExportMode) {
    <button
      class="ui primary button background tiny config-button"
      (click)="openConfigExportConfimationModal()"
    >
      {{ "settings.download-config" | transloco }}
    </button>
    }
  </div>
  }
</div>

@if (countries?.length == 0) {
<p>{{ 'settings.no-countries-found' | transloco: {countryAlias} }}</p>
} @if (!configExportMode && countries?.length > 0) {
<table class="ui striped table">
  <thead>
    <tr class="title">
      <th>{{ 'settings.country-code' | transloco: {countryAlias} }}</th>
      <th>{{ 'settings.country-name' | transloco: {countryAlias} }}</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    @for (c of countries | keyWord: ['countryCode',
    'countryName']:countrySearch; track c) {
    <tr>
      <td>{{ c.countryCode }}</td>
      <td>{{ c.countryName }}</td>
      <td class="edit" align="right" (click)="edit(c)">
        {{ "settings.edit" | transloco }}
      </td>
    </tr>
    }
  </tbody>
</table>
} @if (configExportMode && countries?.length > 0) {
<table class="ui striped table">
  <thead>
    <tr class="title">
      <th>
        <div class="ui checkbox">
          <input
            type="checkbox"
            [(ngModel)]="entireListSelected"
            (change)="entireListSelection()"
          /><label>&nbsp;</label>
        </div>
      </th>
      <th>{{ 'settings.country-code' | transloco: {countryAlias} }}</th>
      <th>{{ 'settings.country-name' | transloco: {countryAlias} }}</th>
      <th>{{ "settings.created" | transloco }}</th>
      <th>{{ "settings.updated" | transloco }}</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    @for (c of countriesForConfigImport | keyWord: ['countryCode',
    'countryName']:countrySearch; track c) {
    <tr>
      <td>
        <div class="ui checkbox">
          <input
            type="checkbox"
            [(ngModel)]="c.selected"
            (change)="listSelection()"
          /><label>&nbsp;</label>
        </div>
      </td>
      <td>{{ c.countryCode }}</td>
      <td>{{ c.countryName }}</td>
      <td>{{ c.displayCreatedAt }}</td>
      <td>{{ c.displayUpdatedAt }}</td>
    </tr>
    }
  </tbody>
</table>
}

<div #configExportConfimationModal class="ui tiny modal config-export-modal">
  <div class="icon modal-close close"></div>
  <p>
    {{ "settings.please-confirm-the-selected-config-to-export" | transloco }}
  </p>
  <table class="ui striped table">
    <thead>
      <tr class="view-modal-title">
        <th>{{ "settings.country-name" | transloco }}</th>
        <th>{{ "settings.updated" | transloco }}</th>
      </tr>
    </thead>
    <tbody>
      @for (c of selectedCountries; track c) {
      <tr>
        <td>{{ c.countryName }}</td>
        <td>{{ c.displayUpdatedAt }}</td>
      </tr>
      }
    </tbody>
  </table>
  @if (!selectedCountries.length) {
  <p>{{ "settings.nothing-selected" | transloco }}</p>
  }
  <button
    class="ui primary button background tiny config-button"
    [ngClass]="{ disabled: !selectedCountries.length }"
    (click)="downloadConfig()"
  >
    {{ "settings.download" | transloco }}
  </button>
</div>
